import { CountryEnv, LANGUAGE } from "@type/index";

const _countryEnv: CountryEnv = {
  clientId: process.env.REACT_APP_CLIENT_ID_ID_UQ || "uq.id.new-styling-book",
  sbRootId: process.env.REACT_APP_FILTERS_SB_ROOT_ID_ID_UQ || 27537,
  shRootId: process.env.REACT_APP_FILTERS_SH_ROOT_ID_ID_UQ || 27538,
  firebaseApiKey: process.env.REACT_APP_FIREBASE_API_KEY_ID_UQ || "",
  firebaseProjectId: process.env.REACT_APP_FIREBASE_PROJECT_ID_ID_UQ || "",
  firebaseAppId: process.env.REACT_APP_FIREBASE_APP_ID_ID_UQ || "",
  firebaseMeasurementId:
    process.env.REACT_APP_FIREBASE_MEASUREMENT_ID_ID_UQ || "",
  storeDomain: process.env.REACT_APP_STORE_DOMAIN_UQ || "",
  showAboutApp: true,
  showDualPrice: true,
  languages: [LANGUAGE.EN, LANGUAGE.ID],
  countryRegion: "Asia/Jakarta",
  timeZone: {
    [LANGUAGE.EN]: {
      defaultTimezone: "WIB",
      offset: {
        WIB: 7
      }
    },
    [LANGUAGE.ID]: {
      defaultTimezone: "WIB",
      offset: {
        WIB: 7
      }
    }
  },
  dateFormat: {
    [LANGUAGE.EN]: "<dd>/<mm>/<yyyy>",
    [LANGUAGE.ID]: "<dd>/<mm>/<yyyy>"
  },
  requireDecimal: true
};

export default _countryEnv;
